import { CheckCircleIcon, MinusCircleIcon } from "@heroicons/react/outline";
import { XIcon } from "@heroicons/react/solid";
import { Renderable } from "react-hot-toast";

export type AppNotificationProps = {
  message: Renderable;
  type?: "success" | "error" | "blank" | "custom" | "loading";
  onClose?: () => void;
};

export default function AppNotification({
  message,
  type,
  onClose,
}: AppNotificationProps) {
  return (
    <div className="flex items-start min-w-[300px]">
      <div className="flex-shrink-0">
        {type === "success" && (
          <CheckCircleIcon
            className="h-6 w-6 ` text-green-400`"
            type="success"
            aria-hidden="true"
          />
        )}
        {type === "error" && (
          <MinusCircleIcon
            className="h-6 w-6 ` text-red-400`"
            type="error"
            aria-hidden="true"
          />
        )}
      </div>
      <div className="ml-3 rtl:mr-3 w-0 flex-1 pt-0.5">
        <p className="mt-1 ml-3 rtl:mr-3 text-sm text-gray-500">{message}</p>
      </div>
      <div className="ml-4 rtl:mr-4 flex-shrink-0 flex">
        <button
          className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
          onClick={onClose}
        >
          <span className="sr-only">Close</span>
          <XIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
